export const extractLastTextMessage = (messageText: string) => {
  const quoteRegex = /\[\[QUOTE id=".+?"\]\]<.+?>: .+?\[\[\/QUOTE\]\](.*)/;
  const match = quoteRegex.exec(messageText);

  if (match) {
    return match[1];
  }

  return messageText;
};
